import { useMemo } from 'react'
import { Box, DatePicker, Flex, Select } from 'ui'
import { usePulseContext } from '../context/PulseProvider'
import { TimePeriod } from 'api/pulse'
import { TIME_PERIOD_OPTIONS } from '../constants'
import { DateRange } from 'react-day-picker'
import { CompaniesSelector } from './CompaniesSelector'
import { getDateRangeFilterPresets } from '../utils'
import { track } from 'lib/amplitude'
import { PositionTypesSelector } from './PositionTypesSelector'

export function FilterBar() {
  const {
    state: { filters },
    actions: { setFilters },
  } = usePulseContext()

  const selectedTimePeriodOption =
    useMemo(() => {
      return TIME_PERIOD_OPTIONS.find(
        (option) => option.value === filters.timePeriod
      )
    }, [filters.timePeriod]) ?? null

  const datePickerPresets = useMemo(() => {
    return getDateRangeFilterPresets()
  }, [])

  return (
    <Flex mt={[0, 2]} mb={[3, 4]} flexWrap={'wrap'}>
      <Box width={[1, 1 / 2, 1 / 2, 2 / 4]} pr={[0, 2]} mb={[2, 2]}>
        <CompaniesSelector />
      </Box>
      <Box width={[1, 1 / 2, 1 / 2, 2 / 4]} pr={[0, 0]} mb={[2, 2]}>
        <PositionTypesSelector />
      </Box>
      <Box width={[1, 1 / 2, 1 / 2, 2 / 4]} pr={[0, 2]} mb={[2, 0]}>
        <Select
          options={TIME_PERIOD_OPTIONS}
          isMulti={false}
          value={selectedTimePeriodOption}
          placeholder={'Filter by Time Period'}
          isClearable={true}
          onChange={(newValue) => {
            track('button_click, pulse_filter_time_period', {
              timePeriod: newValue?.value as TimePeriod,
            })
            setFilters({
              ...filters,
              timePeriod: newValue?.value as TimePeriod,
            })
          }}
        />
      </Box>
      <Box width={[1, 1, 1, 2 / 4]}>
        <DatePicker
          mode={'range'}
          selected={{ from: filters.dateFrom, to: filters.dateTo } as DateRange}
          placeholder={'Pick Date Range'}
          onSelect={(newDates) => {
            if (newDates) {
              const typedDates = newDates as DateRange
              if (typedDates.from && typedDates.to) {
                track('button_click, pulse_filter_date_range', {
                  dateFrom: typedDates.from as Date,
                  dateTo: typedDates.to as Date,
                })
                setFilters({
                  ...filters,
                  dateFrom: typedDates.from as Date,
                  dateTo: typedDates.to as Date,
                })
              }
            }
          }}
          presets={datePickerPresets}
        />
      </Box>
    </Flex>
  )
}
